import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ResponsiveLine, Serie } from "@nivo/line";
import { useTheme } from "@mui/material";
import { useStyles } from "./TrendSlide.styles";
import { NoStatsDataSlide } from "../../../DowntimeCarousel/slides";

interface TrendSlideProps {
    title: string;
    data: Serie[];
}

export const TrendSlide = ({ title, data }: TrendSlideProps) => {
    const classes = useStyles();
    const theme = useTheme();

    const dataMax = Math.max(100, ...data.flatMap((s) => s.data.map((d) => (d.y as number) ?? 0)));
    const yMax = Math.ceil(dataMax / 10) * 10;

    return (
        <Box className={classes.slideContainer}>
            <Typography className={classes.slideTitle}>{title}</Typography>
            {data && data.length > 0 ? (
                <Box className={classes.chartContainer}>
                    <ResponsiveLine
                        data={data}
                        margin={{ top: 20, right: 30, bottom: 40, left: 50 }}
                        xScale={{ type: "point" }}
                        yScale={{ type: "linear", min: 0, max: yMax, stacked: false }}
                        yFormat=" >-.0f"
                        curve="linear"
                        lineWidth={3}
                        colors={["purple"]}
                        pointSize={8}
                        pointColor={"purple"}
                        pointBorderWidth={2}
                        pointBorderColor={"purple"}
                        enablePointLabel={true}
                        pointLabel="yFormatted"
                        pointLabelYOffset={-14}
                        enableGridX={false}
                        enableGridY={true}
                        axisBottom={{
                            tickSize: 5,
                            tickPadding: 5,
                        }}
                        axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            format: (value) => `${value}%`,
                        }}
                        useMesh={false}
                        theme={{
                            axis: {
                                ticks: {
                                    text: {
                                        fontSize: 12,
                                        fontFamily: "Source Sans 3",
                                    },
                                },
                            },
                            grid: {
                                line: {
                                    stroke: theme.palette.border.main,
                                    strokeWidth: 1,
                                },
                            },
                        }}
                    />
                </Box>
            ) : (
                <NoStatsDataSlide />
            )}
        </Box>
    );
};
